import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/message_rule_pb';
import * as pbs from '@/grpc-gen/message_center_service_pb';

import ApiMessageRule, { MessageRuleMapping } from '@/model/MessageRule';
import MessageTemplate from './message-template';

export default class MessageRule extends ApiMessageRule {
  templates: MessageTemplate[] = [];

  static fromGrpcModel(o?: pbm.MessageRule, m?: MessageRuleMapping): MessageRule {
    const messageRule = new MessageRule();

    messageRule.id = Number(o?.id ?? 0);
    messageRule.sendBcc = o?.sendBcc ?? false;
    messageRule.isInactive = o?.isInactive ?? false;
    messageRule.sendDaysAfter = o?.sendDaysAfter || undefined;
    messageRule.sendDaysInAdvance = o?.sendDaysInAdvance || undefined;
    messageRule.sendAtSpecificTime = o?.sendAtSpecificTime ?? '12:00';

    // map related entities using the mapping
    messageRule.campaign = m?.messageCenterCampaignsById.get(Number(o?.campaignId ?? 0)) ?? null;
    messageRule.service = m?.messageCenterServicesById.get(Number(o?.serviceId ?? 0)) ?? null;
    messageRule.eventType = m?.messageCenterEventTypesById.get(Number(o?.eventTypeId ?? 0));
    messageRule.messageType = m?.messageCenterMessageTypesById.get(Number(o?.messageTypeId ?? 0));
    messageRule.tab = m?.messageCenterTabsById.get(Number(o?.tabId ?? 0)) ?? null;

    // map templates
    messageRule.templates = o?.templates?.map((t) => MessageTemplate.fromGrpcModel(t)) ?? [];

    return messageRule;
  }

  static fromGrpcResponse(o?: pbs.MessageRuleResponse, m?: MessageRuleMapping): MessageRule {
    return MessageRule.fromGrpcModel(o?.rule, m);
  }

  toGrpcModel(): pbm.MessageRule {
    return create(pbm.MessageRuleSchema, {
      id: BigInt(this.id),
      sendBcc: this.sendBcc ?? false,
      isInactive: this.isInactive ?? false,
      sendDaysAfter: this.sendDaysAfter ?? 0,
      sendDaysInAdvance: this.sendDaysInAdvance ?? 0,
      sendAtSpecificTime: this.sendAtSpecificTime ?? '12:00',
      messageTypeId: BigInt(this.messageType?.id ?? 0),
      eventTypeId: BigInt(this.eventType?.id ?? 0),
      campaignId: BigInt(this.campaign?.id ?? 0),
      serviceId: BigInt(this.service?.id ?? 0),
      tabId: BigInt(this.tab?.id ?? 0),
      templates: this.templates.length > 0 ? this.templates.map((t) => t.toGrpcModel()) : [],
      accountId: 0n,
    });
  }
}
